// extracted by mini-css-extract-plugin
export var licenseSectionLicenseState = "license-section__license-state_q62u9rEgmXrBsIdLcONU";
export var licenseSectionLicenseStateActive = "license-section__license-state_active_gHplbJL5ua9o7NPEPoEL";